var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"loading":_vm.loading,"value":_vm.selected,"placeholder":_vm.placeholderI18n,"disabled":_vm.disabled},on:{"change":_vm.updateCompany}},_vm._l((_vm.companies),function(ref){
var name = ref.name;
var id = ref.id;
return _c('el-option',{key:name,attrs:{"label":_vm.$t(("companiesFilter." + name)),"value":id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27caa8d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyDropdown.vue
// module id = null
// module chunks = 